import { IItemCache } from '../../../../models/IItemCacheObserver';
import { IDefaultDropActionHandler, IDefaultDropActionHandlerProps } from '../DefaultDropAction';
import { Facet } from '../../../../models/Facet';
import { ItemUploadEntriesAction } from '../../upload/UploadEntriesAction';
import * as React from 'react';
import { folderFacet } from '../../../../facets/ItemFacets';

export const uploadDefaultDropActionHandler: IDefaultDropActionHandler = {
    key: new Facet('uploadDefaultDropActionHandler').id,
    evaluate: (itemCache: IItemCache, props: IDefaultDropActionHandlerProps) => {
        const folder = itemCache.demandItemFacet(folderFacet, props.itemKey);

        return {
            action: folder ? (
                <ItemUploadEntriesAction itemKey={ props.itemKey } />
            ) : undefined
        };
    }
};
